import ApiService from '@/core/services/api.service';

export const LIST_LESSON = 'listLesson';
export const UPDATE_SCORM_LESSON = 'updateScormLesson';
export const SET_LESSON = 'setLesson';
export const SET_ERROR = 'setError';

const state = {
    errors: null,
    lesson: {}
};

const getters = {
    getLesson(state) {
        return state.lesson;
    }
};

const actions = {
    [LIST_LESSON](context, data) {
        return new Promise((resolve) => {
            ApiService.get(process.env.VUE_APP_API_URL, 'academy/lessons/' + data).then((result) => {
                context.commit(SET_LESSON, result.data);
                resolve(result);
            });
        });
    },
    [UPDATE_SCORM_LESSON](context, { lessonId, formData }) {
        return new Promise((resolve, reject) => {
            // Construire l'URL complète pour ApiService.post
            const url = `${process.env.VUE_APP_API_URL}/academy/lessons/scorm/${lessonId}`;
            ApiService.post(url, formData)
                .then((result) => {
                    // Mettre à jour les données de la leçon dans le store
                    // Les données sont dans result.data.lesson.original
                    const lessonData = result.data.lesson.original || result.data.lesson;
                    context.commit(SET_LESSON, lessonData);
                    resolve(result);
                })
                .catch((error) => {
                    context.commit(SET_ERROR, error);
                    reject(error);
                });
        });
    }
};

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
    [SET_LESSON](state, lesson) {
        state.lesson = lesson;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
